const nativeXmlSend = XMLHttpRequest.prototype.send;
const nativeXmlOpen = XMLHttpRequest.prototype.open;
XMLHttpRequest.prototype.open = function(...args) {
	this[Symbol.for('reqUrl')] = args[1] || '';
	nativeXmlOpen.call(this, ...args);
};
XMLHttpRequest.prototype.send = function(...args) {
	const reqUrl = this[Symbol.for('reqUrl')];
	// 浏览器通过Browser Print访问127.0.0.1:9100本地打印机设备信息不需要加上X-CSRFToken，否则会导致跨域问题
	const noCSRFToken = reqUrl.indexOf('?nct=1') !== -1 || ( /.m3u8$|.ts$|.flv$/.test(reqUrl.split('?')[0]) ) || reqUrl.indexOf('127.0.0.1:9100') !== -1;
	if (localStorage.loginToken && !noCSRFToken) {
		this.setRequestHeader('X-CSRFToken', localStorage.loginToken);
	}
	nativeXmlSend.call(this, ...args);
};

const fetchApi = fetch;
window.fetch = function (url, init = {}) {
    console.log('拦截', localStorage, url)
	const { headers = {} } = init;
	if (localStorage.loginToken) {
		headers['X-CSRFToken'] = localStorage.loginToken;
	}
	return fetchApi(url, init);
};
